import { render, staticRenderFns } from "./KnowledgeBaseSearchScreen.vue?vue&type=template&id=c0e5b810&scoped=true&"
import script from "./KnowledgeBaseSearchScreen.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBaseSearchScreen.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBaseSearchScreen.vue?vue&type=style&index=0&id=c0e5b810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e5b810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VSpacer})
